import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { createLoyalty } from '../loyaltyActions';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import { Formik } from 'formik';
import { PrimaryButton } from '../../../components/Buttons';

import FlatButton from '../../../components/Buttons/FlatButton';

const Wrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 40px;
`;
const LinkCard = styled(PrimaryButton)`
  padding: 19px 16px 19px 24px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  &:hover {
    transition: all 0.25s ease;
  }
`;

const FieldWrapper = styled.div`
  margin-bottom: 10px;
`;

const SkipButton = styled(FlatButton)`
  color: ${(props) => props.theme.primaryColor};
  padding: 8px 16px;
  font-size: 19px;
  font-weight: 600;
  margin-top: 20px;
  &:hover {
    transition: all 0.25s ease;
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

const initialLoyaltyCardValues = { loyalty_number: null, pin: null };

export const LoyaltyRegistrationForm = ({
  handleCloseModal,
  setRegistrationStep,
}) => {
  const dispatch = useDispatch();

  const handleLinkLoyaltyCard = useCallback(
    (values) => {
      const { loyalty_number, pin } = values;
      dispatch(createLoyalty(loyalty_number.trim(), pin, setRegistrationStep));
    },
    [dispatch, setRegistrationStep]
  );

  return (
    <Wrapper>
      <Formik
        initialValues={initialLoyaltyCardValues}
        validate={(values) => {
          let errors = {};
          if (!values.loyalty_number) {
            errors.loyalty_number = 'Required';
          }
          if (!values.pin) {
            errors.pin = 'Required';
          }
          return errors;
        }}
        onSubmit={(values) => handleLinkLoyaltyCard(values)}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          dirty,
          isValid,
          setFieldValue,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <FieldWrapper>
              <NumberFormat
                id='ExistingGiftCard-CardNumber'
                label='Loyalty card number'
                name='loyalty_number'
                value={values.loyalty_number}
                onChange={(e) =>
                  setFieldValue('loyalty_number', e.target.value)
                }
                customInput={TextField}
                onBlur={handleBlur}
                error={
                  touched.loyalty_number && errors.loyalty_number ? true : false
                }
                helperText={
                  touched.loyalty_number && errors.loyalty_number
                    ? 'Required'
                    : ''
                }
                style={{ width: '100%' }}
                required
              />
            </FieldWrapper>
            <FieldWrapper>
              <NumberFormat
                id='ExistingGiftCard-Pin'
                label='PIN'
                name='pin'
                value={values.pin}
                onChange={(e) => setFieldValue('pin', e.target.value)}
                customInput={TextField}
                onBlur={handleBlur}
                error={touched.pin && errors.pin ? true : false}
                helperText={touched.pin && errors.pin}
                style={{ width: '100%' }}
                required
              />
            </FieldWrapper>
            <ActionWrapper>
              <LinkCard
                id='ExistingGiftCard-AddGiftCard'
                type='submit'
                disabled={!dirty || !isValid}
              >
                Link My Card
              </LinkCard>
              <SkipButton
                id='ExistingGiftCard-AddGiftCard'
                type='submit'
                onClick={() => setRegistrationStep('welcome')}
              >
                Back to loyalty
              </SkipButton>
            </ActionWrapper>
          </form>
        )}
      </Formik>
    </Wrapper>
  );
};
